import Figure from "../detail/curves/figure"
import { max, flatten } from "lodash"
import { interpolateOrRd, interpolateGnBu } from "d3-scale-chromatic"
import RenderCofabComponent from "../renderCofabComponent"

class Grid extends Component {
  render() {
    const { magnitudes, size } = this.props
    const tileSize = Math.floor(size / magnitudes.length)
    // const peak = max(flatten(magnitudes))

    return (
      <Surface width={size} height={size} borderRadius={5} overflow="hidden">
        <svg width={size} height={size}>
          {magnitudes.map((row, rowIndex) =>
            row.map((col, colIndex) => (
              <rect
                x={colIndex * tileSize}
                y={rowIndex * tileSize}
                width={tileSize}
                height={tileSize}
                fill={col > 0 ? interpolateOrRd(col) : interpolateGnBu(-col)}
              />
            )),
          )}
        </svg>
      </Surface>
    )
  }
}

class ModelChanges extends Component {
  state = { activeLabel: null }
  componentWillMount() {
    this.setState({ activeLabel: this.props.data[this.props.editKey][0].label })
  }

  componentWillReceiveProps({ editKey }) {
    this.setState({ activeLabel: this.props.data[editKey][0].label })
  }

  render() {
    const { activeLabel } = this.state
    const data = this.props.data[this.props.editKey]
    const maxCount = max(data.map(({ count }) => count))

    return (
      <Surface>
        <Surface marginY={10}>
          <Text>New Model Errors</Text>
          {data.map(({ label, count }) => (
            <Surface
              marginY={2}
              flexFlow="row"
              alignItems="center"
              onMouseEnter={() => this.setState({ activeLabel: label })}
            >
              <Text fontWeight={600} width={70} opacity={0.8}>
                {label}
              </Text>
              <Surface
                marginLeft={10}
                height={10}
                width={(200 * count) / maxCount}
                background="rgba(0, 0, 0, 0.05)"
                borderRadius={5}
                style={{ border: "1px solid rgba(0, 0, 0, 0.1)" }}
              />
            </Surface>
          ))}
        </Surface>
        <Surface flexFlow="row">
          {data
            .filter(({ label }) => label === activeLabel)[0]
            ["dataset_examples"].map(({ image, attr }) => (
              <Surface flexFlow="row" marginX={20}>
                <Surface marginRight={10} borderRadius={5} overflow="hidden">
                  <img src={image} />
                </Surface>

                <Grid magnitudes={attr} size={224} />
              </Surface>
            ))}
        </Surface>
      </Surface>
    )
  }
}

class InterventionCircuit extends Component {
  state = { activeIndex: null }
  render() {
    const { data } = this.props
    const { neurons, datasetExamples, saliencyMaps } = data
    const { activeIndex } = this.state

    return (
      <Surface>
        <NewCircuit
          circuit={[
            {
              name: "mixed3b",
              modules: [{ name: "Removed Neuron", neurons: [404] }],
            },
            {
              name: "mixed4b",
              modules: [{ name: "Most Affected Neurons", neurons: neurons }],
            },
          ]}
          onMouseEnter={({ layer, neuron }) => {
            if (layer === "mixed4b") {
              this.setState({ activeIndex: neurons.indexOf(neuron) })
            }
          }}
        />
        {activeIndex !== null && (
          <Surface
            flexFlow="row"
            flexWrap="wrap"
            width={950}
            justifyContent="center"
            alignSelf="center"
          >
            {datasetExamples[activeIndex].slice(0, 9).map((img, index) => (
              <Surface flexFlow="row" marginX={5}>
                <div style={{ marginLeft: 5, marginRight: 5 }}>
                  <img src={img} width={100} height={224 / 2} width={224 / 2} />
                </div>
                <Grid
                  magnitudes={saliencyMaps[activeIndex][index]}
                  size={224 / 2}
                />
              </Surface>
            ))}
          </Surface>
        )}
      </Surface>
    )
  }
}

export default class Interventions extends Component {
  state = { enabled: [true, true, false] }

  onToggle = index => {
    const { enabled } = this.state

    enabled[index] = !enabled[index]

    this.setState({ enabled })
  }

  render() {
    const { enabled } = this.state
    return (
      <React.Fragment>
        <Surface marginY={20}>
          <Text fontSize={40}>Circuit Interventions</Text>
        </Surface>
        <Figure>
          <Surface>
            <RenderCofabComponent
              folder="no-fur"
              component={InterventionCircuit}
            />
          </Surface>
        </Figure>
      </React.Fragment>
    )
  }
}
